import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/Login/LoginPage';
import OTPPage from './pages/Login/OTPPage';
import Dashboard from './pages/Dashboard/Dashboard';
import Devices from './pages/Devices/Devices';
import BulkConfiguration from './pages/Devices/BulkConfiguration';
import Users from './pages/Users/Users';
import Reports from './pages/Reports/Reports';
import Members from './pages/Members/Members';
import Tenants from './pages/Tenants/Tenants';
import HelpCenter from './pages/HelpCenter/HelpCenter';
import Profile from './pages/Profile/Profile';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/otp" element={<OTPPage />} />
      <Route element={<ProtectedRoute requiredRoles={['superadmin', 'admin']}/>}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/users" element={<Users />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/members" element={<Members />} />
          <Route path="/devices/bulk-configuration" element={<BulkConfiguration />} />
          <Route path="/helpcenter" element={<HelpCenter />} />
          <Route path="/profile" element={<Profile />} />
          <Route element={<ProtectedRoute requiredRoles={['superadmin']} />}>
            <Route path="/tenants" element={<Tenants />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
